import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../../zodios/client";
import { isNetworkError } from "../../../../utils/isNetworkError";
import { errorToast } from "../../../../utils/toasts";
import { AMAZON_ONBOARDING_STATUS_QUERY_KEY } from "../../amazon/useAmazonOnboardingStatus";
import type { WalmartOnboardingAction } from "../../../../zodios/apiDefinitions/api/walmart";

export const useMarkWalmartOnboardingStep = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["onboarding", "common"]);

  return useMutation({
    mutationFn: async (payload: WalmartOnboardingAction) => await apiClient.markWalmartOnboardingStep(payload),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["walmart-onboarding-status"] }),
        queryClient.invalidateQueries({ queryKey: ["walmart-marketplace-status"] }),
        queryClient.invalidateQueries({ queryKey: AMAZON_ONBOARDING_STATUS_QUERY_KEY }),
      ]);
    },
    onError: (error) => {
      errorToast({
        message:
          isNetworkError(error) ?
            t(($) => $.onboarding["Something went wrong. Check your connection and try again."])
          : t(($) => $.common["Something went wrong. Please try again."]),
        error,
      });
    },
  });
};
